import { motion } from "framer-motion";
import BlockProse from "@/components/blocks/renderers/BlockProse";

/**
 * Full-width centered hero. Renders eyebrow badge, big title with optional
 * accent word in sky-blue, and a subtitle paragraph (rich-text capable).
 */
export default function HeroBlock({ data }) {
  const { eyebrow, title, title_accent, subtitle } = data || {};
  return (
    <section className="pt-32 pb-14 lg:pt-40 lg:pb-20 bg-white">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          {eyebrow && (
            <span className="inline-block text-xs font-bold uppercase tracking-widest text-sky-700 bg-sky-100 border border-sky-200 rounded-full px-3 py-1 mb-4">
              {eyebrow}
            </span>
          )}
          <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight text-slate-900">
            {title}
            {title_accent ? <> <span className="text-sky-600">{title_accent}</span></> : null}
          </h1>
          <div className="mt-5">
            <BlockProse
              value={subtitle}
              proseClassName="prose prose-slate max-w-2xl mx-auto prose-p:text-slate-500 prose-a:text-sky-600 prose-a:no-underline hover:prose-a:underline text-base lg:text-lg"
              plainClassName="text-base lg:text-lg text-slate-500 leading-relaxed max-w-2xl mx-auto whitespace-pre-line"
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
}
